import { get, post } from '../../../../infra/rest';
import requestConfig from '../../../../shared/config/request';
import { AiBotType, AIFeaturePermissionResponse, GenerateReplyResponse } from '../typings';

export const isDefaultBotSetup = async (): Promise<AiBotType> => {
  return get<AiBotType>(`${requestConfig.aiBotBaseUrl}/v1/ai-bot/default/bot`, undefined, true, false, true);
};

export const generateReply = async ({ chatId }: { chatId: string }): Promise<GenerateReplyResponse> => {
  return get<GenerateReplyResponse>(
    `${requestConfig.aiBotBaseUrl}/v1/ai/chats/${chatId}/generate-reply`,
    undefined,
    true,
    false,
    true
  );
};

export const rephraseTextApi = async ({ text }: { text: string }): Promise<{ rephrasedText: string }> => {
  return post<{ rephrasedText: string }>(
    `${requestConfig.aiBotBaseUrl}/v1/ai/organizations/chat/rephrase`,
    {
      body: JSON.stringify({
        text,
      }),
    },
    true,
    false,
    true
  );
};

export const checkAIFeaturePermissionApi = async (): Promise<AIFeaturePermissionResponse> => {
  return get<AIFeaturePermissionResponse>(
    `${requestConfig.aiBotBaseUrl}/v1/ai/organizations/feature-permissions`,
    undefined,
    true,
    false,
    true
  );
};
